module.exports = __webpack_public_path__ + "static/img/7.e615cf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/7.png
// module id = AbPn
// module chunks = 0